import { Dialog, DialogContent, DialogTitle, DialogDescription } from '@/components/ui/dialog'
import BroadcastDevicePage from '@/pages/broadcastDevice/page'

interface BroadcastDeviceSettingDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  clinicId: number
  broadcastDeviceId?: number
  onMutate?: () => void
}

export function BroadcastDeviceSettingDialog({
  open,
  onOpenChange,
  clinicId,
  broadcastDeviceId,
  onMutate,
}: BroadcastDeviceSettingDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[90vw] h-[90vh] max-w-[90vw] max-h-[90vh] p-0 overflow-hidden flex flex-col">
        <DialogTitle className="sr-only">廣播裝置設定</DialogTitle>
        <DialogDescription className="sr-only">
          在這裡管理廣播裝置的基本資訊與相關設定
        </DialogDescription>
        <BroadcastDevicePage
          clinicId={clinicId}
          broadcastDeviceId={broadcastDeviceId}
          onOpenChange={onOpenChange}
          onMutate={onMutate}
        />
      </DialogContent>
    </Dialog>
  )
}
